import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.orderItems.routesDialog.title',
    defaultMessage: 'Change route',
    description: 'Title of the routes dialog',
  },
  feedback: {
    routeChanged: {
      id: 'orderItemsGrid.feedback.routeChanged',
      defaultMessage: 'Route changed',
      description: 'Success message of the change route action',
    },
    routeNotChanged: {
      id: 'orderItemsGrid.feedback.routeNotChanged',
      defaultMessage: 'Route could not be changed',
      description: 'Error message of the change route action',
    },
  },
};

export default defineMessages(translations);
